module.exports = __webpack_public_path__ + "img/Weapon_173.a6e33796.png";